import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import header from '../asset/4.png';
import TopNavbarre from './topnavbarre';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    telephone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch('https://formspree.io/f/xkgbrkze', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    if (response.ok) {
      setSubmitted(true);
      setFormData({
        prenom: '',
        nom: '',
        telephone: '',
        message: '',
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleScroll = (e) => {
    e.preventDefault();
    const contentSection = document.getElementById('content');
    if (contentSection) {
      contentSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <>
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center 30%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        <TopNavbarre/>
        
        <div className="relative z-10 flex-grow flex items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-2 sm:mb-4"
              >
                Entrez en contact avec <span className="text-blue-400">notre équipe</span>
              </motion.h1>
              
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-lg"
              >
                Une question ? Un projet d'étude ? Notre équipe est à votre écoute pour vous accompagner pas à pas.
              </motion.p>
              
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex flex-col sm:flex-row gap-3 sm:gap-4"
              >
                <Link
                  to="#content"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                  onClick={handleScroll}
                >
                  Ton avenir débute ici
                </Link>
              </motion.div>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#content" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      <section id="content" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Comment pouvons-nous vous aider ?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Notre équipe d'experts est là pour vous accompagner dans votre projet d'études en France.
              N'hésitez pas à nous contacter pour toute question.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-b from-blue-700 to-blue-800 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16 sm:block"
          >
            <span className="inline-block bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
              Nous contacter
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Restons <span className="text-blue-200">en contact</span>
            </h2>
            <p className="text-lg text-blue-100 max-w-3xl mx-auto">
              Notre équipe est disponible pour répondre à toutes vos questions
            </p>
          </motion.div>

          <motion.div 
            initial="hidden"
            whileInView="show"
            variants={container}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-16 sm:grid"
          >
            <motion.div variants={item}>
              <div className="bg-white text-blue-700 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="flex flex-col items-center text-center h-full">
                  <div className="bg-blue-100 text-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                    <FaPhoneAlt className="text-xl" />
                  </div>
                  <h3 className="font-bold uppercase text-sm mb-2">Téléphone</h3>
                  <p className="text-sm mb-1">+24206 172 81 62</p>
                  <p className="text-sm">+33 7 58 72 82 89</p>
                </div>
              </div>
            </motion.div>

            <motion.div variants={item}>
              <div className="bg-white text-blue-700 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="flex flex-col items-center text-center h-full">
                  <div className="bg-blue-100 text-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                    <FaEnvelope className="text-xl" />
                  </div>
                  <h3 className="font-bold uppercase text-sm mb-2">Email</h3>
                  <p className="text-sm mb-1">contact@franceetudes.com</p>
                  <p className="text-sm">info@franceetudes.com</p>
                </div>
              </div>
            </motion.div>

            <motion.div variants={item}>
              <div className="bg-white text-blue-700 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="flex flex-col items-center text-center h-full">
                  <div className="bg-blue-100 text-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                    <FaMapMarkerAlt className="text-xl" />
                  </div>
                  <h3 className="font-bold uppercase text-sm mb-2">Adresse</h3>
                  <p className="text-sm mb-1">03 Rue Bomitaba, avenue Maya Maya, 1er étage,</p>
                  <p className="text-sm">Moungali, Brazzaville</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-16 rounded-xl overflow-hidden shadow-xl"
          >
            <iframe
              title="google-map"
              src="https://maps.google.com/maps?q=03+Rue+Bomitaba,+avenue+Maya+Maya,+Moungali,+Brazzaville&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="400"
              className="border-0"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </motion.div>
        </div>
      </section>

      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden"
          >
            <div className="p-8 md:p-12">
              <div className="text-center mb-10">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                  <span className="text-gray-800">Prise de </span>
                  <span className="text-blue-600">contact</span>
                </h3>
                <p className="text-gray-600 max-w-lg mx-auto">
                  Remplissez ce formulaire et nous vous répondrons dans les plus brefs délais
                </p>
              </div>

              <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto" action="https://formspree.io/f/xkgbrkze"
              method="POST">
                <motion.div whileHover={{ scale: 1.02 }} className="sm:col-span-1">
                  <input 
                    type="text" 
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    placeholder="Prénom" 
                    className="p-4 rounded-lg border border-gray-300 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                    required
                  />
                </motion.div>
                <motion.div whileHover={{ scale: 1.02 }} className="sm:col-span-1">
                  <input 
                    type="text" 
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder="Nom" 
                    className="p-4 rounded-lg border border-gray-300 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                    required
                  />
                </motion.div>
                <motion.div whileHover={{ scale: 1.02 }} className="sm:col-span-2">
                  <input 
                    type="tel" 
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    placeholder="Numéro de téléphone" 
                    className="p-4 rounded-lg border border-gray-300 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition" 
                    required
                  />
                </motion.div>
                <motion.div whileHover={{ scale: 1.02 }} className="sm:col-span-2">
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Votre message" 
                    rows="5" 
                    className="p-4 rounded-lg border border-gray-300 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    required
                  ></textarea>
                </motion.div>
                <motion.div className="sm:col-span-2">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit" 
                    className="bg-blue-600 hover:bg-blue-700 text-white py-4 px-8 rounded-lg font-semibold w-full sm:w-auto sm:mx-auto transition flex items-center justify-center gap-2"
                  >
                    {submitted ? 'Message envoyé !' : (<> <FaPaperPlane /> Envoyer </>)}
                  </motion.button>
                </motion.div>
              </form>
              {submitted && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mt-6 text-center"
                >
                  <p className="text-green-600 font-medium">
                    Merci pour votre message ! Nous vous contacterons dans les 48 heures.
                  </p>
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;